<template>
    <div>
        <p class="has-text-weight-bold mb-2">{{ translateRule(ruleData.rule) }}</p>
        <div>
            {{ translate("page.admin_academy_results.points_for_medals") }}
            <span v-for="medalPoint in medalPoints" :key="medalPoint.medal">
                <span :class="getMedalClass(medalPoint.medal)"> #{{ medalPoint.medal }} </span>: {{ medalPoint.points }}
            </span>
        </div>
        <div>
            <span class="icon">
                <i class="has-text-success fa fa-check-circle" v-if="ruleData.input.excludeOneManCategories" />
                <i class="has-text-danger fa fa-times-circle" v-else />
            </span>
            <span>
                {{ translate("page.admin_academy_results.dont_count_one_competitor_categories") }}
            </span>
        </div>
        <div>
            <span class="icon">
                <i class="has-text-success fa fa-check-circle" v-if="ruleData.input.excludeOneAcademyCategories" />
                <i class="has-text-danger fa fa-times-circle" v-else />
            </span>
            <span>
                {{ translate("page.admin_academy_results.dont_count_one_team_categories") }}
            </span>
        </div>
    </div>
</template>

<script setup lang="ts">
    import { ScoreForAwardedMedalsRule } from "../../../Api/competitorResultsApi";
    import { translateRule } from "../addRuleStore";
    import { computed } from "vue";
    import { translate } from "../../../Common/translations";

    const props = defineProps<{
        ruleData: ScoreForAwardedMedalsRule;
    }>();

    const medalPoints = computed<{ medal: number; points: number }[]>(() => {
        return Object.keys(props.ruleData.input.pointsForMedals).map(medal => {
            return {
                medal: Number(medal),
                points: props.ruleData.input.pointsForMedals[medal] as number,
            };
        });
    });

    function getMedalClass(medal: number) {
        if (medal > 3) {
            return "academy-medal is-extended";
        }

        return `academy-medal medal-${medal}`;
    }
</script>

<style scoped></style>
